var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6.152 6.151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M84 240h24v24H84z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 -22.324 -63.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.625 251.915c-.008.328-.209.611-.55.775l-4.265 2.081 3.737 3.738a.33.33 0 0 1 0 .464l-3.573 3.573a.33.33 0 0 1-.464 0l-3.737-3.738-2.082 4.268c-.164.339-.447.54-.775.548h-.023c-.384 0-.714-.236-.808-.581L91.1 248.182c-.09-.345-.017-.656.205-.879.22-.22.54-.295.878-.205l14.861 3.986c.352.094.592.435.582.831m-16.5 2.061a6.06 6.06 0 0 1-3.55-1.744 6.08 6.08 0 0 1-1.794-4.329c0-1.635.637-3.173 1.794-4.33a6.13 6.13 0 0 1 8.66 0 6.07 6.07 0 0 1 1.743 3.551.703.703 0 0 0 1.395-.177 7.47 7.47 0 0 0-2.144-4.368c-2.936-2.936-7.712-2.936-10.648 0a7.48 7.48 0 0 0-2.206 5.324c0 2.011.784 3.901 2.206 5.323a7.46 7.46 0 0 0 4.367 2.145q.045.005.09.005a.703.703 0 0 0 .088-1.4zm2.937-8.228q.31.31.519.691a.703.703 0 1 0 1.234-.673 4.461 4.461 0 0 0-7.062-1.014 4.43 4.43 0 0 0-1.305 3.151c0 1.19.464 2.309 1.306 3.151.3.301.641.557 1.012.76a.707.707 0 0 0 .954-.279.704.704 0 0 0-.278-.955 3 3 0 0 1-.694-.521 3.03 3.03 0 0 1-.893-2.156c0-.814.317-1.58.893-2.156a3.054 3.054 0 0 1 4.314.001"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClick);
export default __webpack_public_path__ + "static/media/click.19e2f586adb417249134c2276ae2896e.svg";
export { ForwardRef as ReactComponent };